import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useTenant } from '../../contexts/TenantContext';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';
import LumoCharacter from './components/LumoCharacter';
import WelcomeMessage from './components/WelcomeMessage';
import CoachingMethodology from './components/CoachingMethodology';
import InteractiveDemo from './components/InteractiveDemo';
import CoachingModules from './components/CoachingModules';
import QuickTips from './components/QuickTips';
import { supabase } from '../../lib/supabase';

const MeetLumo = () => {
  const navigate = useNavigate();
  const { updateProfile, refreshProfile } = useAuth();
  const { tenantSlug } = useTenant();

  // Mark that user has seen Lumo intro (won't show again)
  useEffect(() => {
    const markLumoSeen = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        
        if (session?.user) {
          await supabase
            .from('user_profiles')
            .update({ has_seen_lumo: true })
            .eq('id', session.user.id);
          
          localStorage.setItem('hasSeenLumo', 'true');
        }
      } catch (err) {
        console.error('Error marking Lumo as seen:', err);
      }
    };

    markLumoSeen();
  }, []);

  const handleGetStarted = () => {
    // Redirect to Whop subscription page
    window.location.href = 'https://whop.com/earn-my-edge/earnmyedge/';
  };

  return (
    <div className="min-h-screen bg-background">
      <div className="main-content max-w-7xl mx-auto">
        <div className="py-8 md:py-12">
          <LumoCharacter />
          <WelcomeMessage />
          <CoachingMethodology />
          <InteractiveDemo />
          <CoachingModules />
          <QuickTips />

          <div className="max-w-2xl mx-auto px-4 text-center">
            <div className="bg-gradient-to-br from-primary/10 to-accent/10 rounded-2xl p-8 border border-border mb-8">
              <Icon name="Rocket" size={48} color="var(--color-primary)" className="mx-auto mb-4" />
              <h2 className="text-2xl font-bold text-foreground mb-4">
                Ready to Transform Your Sales Skills?
              </h2>
              <p className="text-muted-foreground mb-6 leading-relaxed">
                Join thousands of sales professionals who are improving their skills daily with Lumo. Your journey to sales mastery starts now.
              </p>
              <Button
                variant="default"
                size="lg"
                fullWidth
                onClick={handleGetStarted}
                iconName="Rocket"
                iconPosition="right"
                className="mb-4"
              >
                Get Started
              </Button>
              <p className="text-xs text-muted-foreground">
                Takes less than 10 minutes per day • Cancel anytime
              </p>
            </div>

            <div className="flex items-center justify-center gap-6 text-sm text-muted-foreground">
              <div className="flex items-center gap-2">
                <Icon name="Shield" size={16} color="var(--color-success)" />
                <span>Secure & Private</span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="Zap" size={16} color="var(--color-accent)" />
                <span>AI-Powered</span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="Award" size={16} color="var(--color-primary)" />
                <span>Proven Results</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeetLumo;
